import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=3e963fca&scoped=true"
import script from "./Record.vue?vue&type=script&lang=js"
export * from "./Record.vue?vue&type=script&lang=js"
import style0 from "./Record.vue?vue&type=style&index=0&id=3e963fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e963fca",
  null
  
)

export default component.exports